import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addNewOption: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.add-new-option',
		defaultMessage: 'Add option',
		description: 'Button to add new option when editing list of options in Dropdown field settings',
	},
	newOption: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.new-option',
		defaultMessage: 'Option 1',
		description:
			'Option that is added when new Field is created so there is something instead of empty place',
	},
	addButtonDisabledMaxOptions: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.add-button-disabled-max-options',
		defaultMessage: "You can't add more than {maxOptions} field options",
		description:
			'Tooltip shown on the add option button when the maximum number of options for a field has been reached',
	},
	addButtonDisabledNoModify: {
		id: 'issue-type-page.field-associated.field-configuration.field-options.add-button-disabled-no-modify',
		defaultMessage: 'You can’t add an option',
		description: "Tooltip shown on the add option button when a user can't add options",
	},
	optionPlaceholder: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.option-placeholder',
		defaultMessage: 'Option {index}',
		description:
			'Displayed if the option is empty. Index is just a number, f.in. Option 1, Option 2 etc.',
	},
	errorKeyDuplicate: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.error-key-duplicate',
		defaultMessage: 'Already exists. Try something else.',
		description: 'validation error displayed if field option is duplicate',
	},
	errorKeyEmpty: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.error-key-empty',
		defaultMessage: 'Give the option a name.',
		description: 'validation error displayed if field option is empty',
	},
	errorKeyInvalid: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.field-with-options.error-key-invalid',
		defaultMessage: 'Add some options for people to choose from.',
		description: 'validation error displayed if there are no options at all but they are required',
	},
});
